import { render, staticRenderFns } from "./change_password.html?vue&type=template&id=3f43d848&scoped=true&"
import script from "./change_password.js?vue&type=script&lang=js&"
export * from "./change_password.js?vue&type=script&lang=js&"
import style0 from "./change_password.scss?vue&type=style&index=0&id=3f43d848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43d848",
  null
  
)

export default component.exports